import { useResponsive } from '@shared/utils/hooks/useResponsive';
import { ScheduleDayProps } from '../ScheduleDisplay';
import React from 'react';
import { TwoColumnDesktopDay } from './desktop/TwoColumnDesktop';
import { TwoColumnMobileDay } from './mobile/TwoColumnMobile';
import { useLayout } from '@apps/guest/packages/layout-engine/layouts/LayoutProvider';
import { DesignLayoutType } from '@graphql/generated';

export const TWO_COLUMN_MOBILE_BREAKPOINT = 300;

export const TwoColumnSchedule = (props: ScheduleDayProps) => {
  const [isMobile] = useResponsive({ values: { [TWO_COLUMN_MOBILE_BREAKPOINT]: true, tablet: false } }, false);
  const layoutType = useLayout();
  const isAloha = layoutType.layout === DesignLayoutType.aloha;

  if (isMobile || isAloha) {
    return <TwoColumnMobileDay {...props} />;
  } else {
    return <TwoColumnDesktopDay {...props} />;
  }
};
